
import React from 'react'

export default React.createClass({
  render() {
    return (
      <div className="bg-lb height100">

      <div className="overview_wrapper">  
        

      <h1><a href="#target">Getting Started</a></h1>
      <p><a href="#target">Connect to an Ethereum node</a></p>
      <p><a href="#target">Withdraw funds</a></p>
      
   
      <h1>Making Purchases</h1>
      <p>Using the Buyer dashboard</p>
      <p>Sending an Escrow protected transaction</p>
      <p>How does EscrowMyEther buyer protection work?</p>
      
      <p>How does dispute resolution work</p>
      <p>Receiving refunds from Seller</p>
      <p>Create/Update your buyer profile</p>

       
      <h1>Selling on EscrowMyEther</h1>
      <p>Using the Seller dashboard</p>
      <p>Benefits of selling on EscrowMyEther</p>
      
      <p>Fees</p>
      <p>How does dispute resolution work</p>
      <p>Receiving payment from Buyer</p>
      
      <p>Create/Update your Seller profile</p>

      <h1>Offer Escrow Services</h1>
      <p>Setup percentage fee per transaction</p>
      <p>Using the Escrow dashboard</p>
      <p>Resolving disputes</p>
      
      <p>Create/Update your Escrow profile</p>
      <br/><br/><br/>
      <h1><a id="getstarted">Getting Started</a></h1>
      <h2>Connect to an Ethereum node</h2>
      <p>To begin using EscrowMyEther, connection to an Ethereum node is required. We recommend Metamask or Parity chrome extension for their ease of use
      Chrome Extensions <br/><br/>
      -	Parity: https://chrome.google.com/webstore/detail/parity-ethereum-integrati/himekenlppkgeaoeddcliojfddemadig<br/>
      -	Metamask: https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn
      <br/><br/>
      Once EscrowMyEther detects a connection to Parity or Metamask (or your own Ethereum node), you can begin interacting with the app. Note for Parity, you will need to wait for the node to sync with the network.
      </p>

      <h2>Withdraw Funds</h2>
      <p>Funds are transferred to your ownership when the following happens
      <br/><br/>
      -	Buyer releases funds to Seller<br/>
      -	Seller refunds to buyer<br/>
      -	A transaction you were escrowing for is complete, either funds released or refunded<br/><br/>
      The funds are held in the smart contract, under “Contract Balance”. At any time you can click withdraw balance to move the funds out of the contract to your address. Multiple transactions can be accumulated before withdrawing.
      </p>

      <br/><br/><br/>

      <h1>Using the buyer dashboard</h1>
      <h2>Create new transaction</h2>
      <p>
      1)	Begin creating new transactions by clicking “Initialize new transaction” under address balance on your buyer dashboard.<br/>
      2)	Select your address from the dropdown<br/>
      3)	Enter Seller’s address<br/>
      4)	Enter Escrow’s address<br/>
      Note: Work with your seller to choose an escrow agent, such as the forum moderator if you are trading in a forum. Never accept the transaction if the seller proposes an unknown escrow, as they can be the same person!
      <br/>
      5)	Enter amount of Ether to send before fees.
      <br/>
      6)  Click proceed to confirmation and sign the transaction in Metamask or Parity.
      </p>

      <h2>Releasing funds</h2>
      <p>If the status is marked as “In progress” or “Pending Escrow decision”, you can activate “Release funds”. This completes the transaction and moves ownership of the funds to the Seller. “Release funds” cannot be activated if the status is marked “Complete” or “Complete (Refunded)”.</p>
      
      <h2>Request Escrow Assistance</h2>
      <p>If status is marked “In progress” and you face issues that cannot be solved with the Seller, you can activate “Request escrow assistance”. This unlocks the escrow agent’s ability to interact with the transaction. After activating the function, inform your escrow agent of the issue in detail.</p>
      
      
      
      <h2>Modify Buyer profile</h2>
      <p>Click “Modify profile” on the buyer dashboard to update your buyer name and info. In the future, sellers and escrow agents can see your buyer name in their history. A search function is also being built which shows your name and info.</p>

      <h2>Receiving Refunds</h2>
     
      <p>When the seller or escrow agent refunds your order, the funds will be moved to your ownership, under “Contract balance”. At any time contract funds can be withdrawn. For more information, see Withdraw Funds FAQ. Refunded orders are marked with a “Complete (Refunded)” status.</p>
      <br/><br/><br/>
      
      
      <h1>Using the seller dashboard</h1>
      <h2>Refund Buyer</h2>
      <p>If the status is marked as “In progress” or “Pending Escrow decision”, you can enter the sale ID and activate “Refund Buyer”. This completes the transaction and moves ownership of the funds to the buyer. “Refund Buyer” cannot be activated if the status is marked “Complete” or “Complete (Refunded)”.</p>
      
      
      
      <h2>Request Escrow Assistance</h2>
      <p>If status is marked “In progress” and you face issues that cannot be solved with the buyer, you can enter the sale ID and activate “Request escrow assistance”. This unlocks the escrow agent’s ability to interact with the transaction. After activating the function, inform your escrow agent of the issue in detail.</p>
      
      <h2>Modify Seller profile</h2>
      
      <p>Click “Modify profile” on the seller dashboard to update your seller name and info. In the future, buyer and escrow agents can see your buyer name in their history. Your seller name is also shown as buyers enter your address when creating a new transaction. We highly recommend updating your profile to improve buyer’s confidence.</p>
      
      
      <h2>Collecting payment from complete transactions</h2>
      
      
      <p>When the buyer or escrow agent releases funds from a transaction, the funds will be moved to your ownership, under “Contract balance”. At any time contract funds can be withdrawn. For more information, see Withdraw Funds FAQ. </p>
      <br/><br/><br/>
      

      <h1>Being an Escrow Agent</h1>
      <h2>Using refund buyer</h2>
      <p>If the status is marked as “Pending Escrow decision”, you can activate “Refund Buyer”. This completes the transaction and moves ownership of the funds to the buyer. “Refund Buyer” cannot be activated if the status is marked “Complete”, “Complete (Refunded)” or “In progress”. </p>
      
      <h2>Using release funds </h2>
      <p>If the status is marked as “Pending Escrow decision”, you can activate “Release funds”. This completes the transaction and moves ownership of the funds to the Seller. “Release funds” cannot be activated if the status is marked “Complete”,  “Complete (Refunded)” or “In progress”.</p>
      
      <h2>Modify escrow profile and Set fees</h2>
      <p>Click “Modify profile” on the escrow dashboard to update your escrow name, info and set fees. In the future, buyer and sellers can see your escrow name in their history. Your escrow name is also shown as buyers enter your address when creating a new transaction. We highly recommend updating your profile to improve buyer’s confidence.</p>


      <h2>Collecting fees from complete transactions</h2>
      <p>When the transaction is completed, the escrow fees will be moved to your ownership, under “Contract balance”. At any time contract funds can be withdrawn. For more information, see Withdraw Funds FAQ.</p>
      </div>
      </div>
    )
  }
})


// WEBPACK FOOTER //
// ./src/Help.js